/* eslint-disable react/prop-types */
import { useEffect, useState } from "react";
import Card from "@mui/material/Card";
import { formatDate, formatCurrency } from "utils";
import SoftBox from "components/SoftBox";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

import DataTable from "./DataTable";
import ActionCell from "./components/ActionCell/index";
import { CustomerPaymentDetailsLedgerService } from "services/customer-payment-details-ledger";

const renderData = (items, setDataTable) => {
  return items.map((item) => {
    return {
      id: item._id,
      accountNumber: item.accountNumber || "N/A",
      entityName: item.entityName || "N/A",
      openingBalance: formatCurrency.format(
        (item.openingBalance?.debit || 0) + (item.openingBalance?.credit || 0)
      ),
      totalIncurredDebit: formatCurrency.format(item.totalIncurred?.debit || 0),
      totalIncurredCredit: formatCurrency.format(item.totalIncurred?.credit || 0),
      createdAt: formatDate(item.createdAt),
      action: <ActionCell item={item} setDataTable={setDataTable} />,
    };
  });
};

const tableData = {
  columns: [
    { Header: "Tài khoản", accessor: "accountNumber", width: "15%" },
    { Header: "Đối tượng", accessor: "entityName", width: "20%" },
    { Header: "Tổng Số dư đầu", accessor: "openingBalance", width: "15%" },
    { Header: "Phát sinh Nợ", accessor: "totalIncurredDebit", width: "15%" },
    { Header: "Phát sinh Có", accessor: "totalIncurredCredit", width: "15%" },
    { Header: "Ngày tạo", accessor: "createdAt", width: "10%" },
    { Header: "Thao tác", accessor: "action", sorted: false },
  ],
  rows: [],
};

function CustomerPaymentDetailsLedger() {
  const [loading, setLoading] = useState(false);
  const [dataTable, setDataTable] = useState(tableData);
  const [query, setQuery] = useState({ sortBy: "createdAt", sortType: "desc" });
  const [checkCreate, setCheckCreate] = useState(true);
  const [paginationData, setPaginationData] = useState({
    page: 1,
    count: 0,
    size: 10,
  });

  useEffect(() => {
    fetchData();
  }, [query, paginationData.page]);

  const fetchData = async () => {
    try {
      setLoading(true);
      const response = await CustomerPaymentDetailsLedgerService.getPaginate({
        ...query,
        page: paginationData.page,
        size: paginationData.size,
      });

      const { items = [], checkCreate: createPerm, paginate } = response.data || response;
      setCheckCreate(createPerm ? false : true);
      setPaginationData((prev) => ({
        ...prev,
        count: paginate?.count || 0,
        size: paginate?.size || 10,
      }));

      setDataTable((prev) => ({
        ...prev,
        rows: renderData(items, setDataTable),
      }));
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error("Lỗi lấy dữ liệu Sổ S31-DN:", error);
      setDataTable((prev) => ({ ...prev, rows: [] }));
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <SoftBox my={3}>
        <Card style={{ height: "100%" }}>
          <DataTable
            checkCreate={checkCreate}
            query={query}
            table={dataTable}
            loading={loading}
            setQuery={setQuery}
            paginationData={paginationData}
            setPaginationData={setPaginationData}
          />
        </Card>
      </SoftBox>
    </DashboardLayout>
  );
}

export default CustomerPaymentDetailsLedger;
